import { useTranslation } from "react-i18next";

export const MissingReasonAlert = () => {
  const { t } = useTranslation();

  return <div className="p-1 error-msg reason-alert">{t("articleListView.errorMessages.missingReason")}</div>;
};

export default MissingReasonAlert;
